<template>
    <div class="announcments service-listing">
        <div class="row">
            <div class="col-sm-3 col-lg-3 tablet-full-width">
                <div class="filter-component">
                    <filterservice :apiResponse="info"
                                   :FilterByDate="FilterByDate"
                                   :filter="getData"
                                   @depArr="depArr = $event"
                                   @ruleArr="ruleArr = $event"
                                   @sectorArr="sectorArr = $event"
                                   @subArr="subArr = $event"
                                   @healthArr="healthArr = $event"
                                   @funcArr="funcArr = $event"
                                   @tarckApplyFilter="tarckApplyFilter = true"
                                   :PageType="PageType"
                                   :CategoriesOfRules="CategoriesOfRules"
                                   :announcement="announcement"
                                   v-if="info && (services || announcement)"
                                   :sectorLab="SectorLabel"
                                   :categoryLab="CategoryLabel"
                                   :productLab="ProductsLabel"
                                   :functionsLab="FunctionsLabel"
                                   :searchLab="SearchLabel"
                                   @datestart="datestart = $event"
                                   @dateend="dateend = $event"
                                   @resetDate="resetDate = $event"
                                   :ClearDateFilter="ClearDateFilter"
                                   :Apply="Apply"
                                   :Reset="Reset"
                                   :From="From"
                                   :key="reinitFilter"
                                   :To="To"
                                   :Required="Required"
                                   :BackBtn="BackBtn" />
                    <div class="generic-loader filter-loader" v-if="apiCallLoader">
                        <img src="../../../Assets/Images/spinner.svg" />
                    </div>
                </div>
                
            </div>
            <div class="col-sm-9 col-lg-9 tablet-full-width">
                <div class="accordion-wrapper">
                    <servicesearch @searchKeyword="searchWord = $event, searchClicked = true"
                                   :searchFilter="getData"
                                   :searchLab="SearchLabel"
                                   :searchPlaceHolder="SearchPlaceHolder" />
                    <h3 v-if="noDataMsg" class="empty-msg">
                        {{ NoResultMessage }}
                    </h3>

                    <div class="accordion"
                         id="accordionExample"
                         v-if="filteredData.length != 0">
                        <Announcement-card :AnnouncementArr="filteredData"></Announcement-card>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import AnnouncementCard from "../GenericListingComponent/AnnouncementBlock/AnnouncementCard.vue";

import servicesearch from "../ServiceSearch/ServiceSearch.vue";
import filterservice from "../GenericPageComponent/Filter/FilterService.vue";

import axios from "axios";
let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
let language = window.CurrentLanguage.CurrentLanguage;
export default {
  data() {
    return {
      announcement: true,
      rules: false,
      services: false,
      reinitFilter: 0,

      searchWord: "",
      infoData: [],
      info: [],
      pageNumber: 1,
      noDataMsg: false,
      apiCallLoader: false,
      filteredData: [],
      limit: 2,
      Categories: [],
      datestart: "",
      dateend: "",
      depArr: [],
      funcArr: [],
      healthArr: [],
        cateArr: [],
        searchClicked: false
    };
  },
  components: {
    servicesearch,
    filterservice,
    AnnouncementCard,
  },
  props: {
    BackBtn: {
      type: String,
    },
    PageType: {
      type: String,
    },
    checkSector: {
      type: Boolean,
    },
    Required: {
      type: String,
    },
    SearchLabel: {
      type: String,
    },
    searchPlaceHolder: {
      type: String,
    },
    checkCateg: {
      type: String,
    },
    To: {
      type: String,
    },
    From: {
      type: String,
    },
    ClearDateFilter: {
      type: String,
    },
    FilterByDate: {
      type: String,
    },
    CategoriesOfRules: {
      type: String,
    },

    CategoryLabel: {
      type: String,
    },
    SectorLabel: {
      type: String,
    },
    FunctionsLabel: {
      type: String,
    },
    SearchPlaceHolder: {
      type: String,
    },
    ProductsLabel: {
      type: String,
    },
    NoResultMessage: {
      type: String,
    },
    Apply: {
      type: String,
    },
    Reset: {
      type: String,
    },
  },
  methods: {
    getData() {
      if (window.innerWidth > 1025) {
        this.apiCallLoader = true;
      }
      this.isAjaxLoading = true;
      this.noDataMsg = false;
      if (this.searchWord != "" || this.tarckApplyFilter == true || this.searchClicked) {
        this.pageNumber = 1;
        this.filteredData = [];
      }
      this.infoData = [];

      let body = {
        DateFrom: this.datestart,
        DateTo: this.dateend,
        Sectors: this.sectorArr,
        PageType: "announcements",
        PageNumber: this.pageNumber,
          Categories: this.ruleArr,
        Departments: [],
        HealthProducts: this.healthArr,
        Functions: this.funcArr,
        Text: this.searchWord,
      };

      axios
        .post(`${apiUrl}/Umbraco/Surface/Generic/ApplyFilters?culture=${language}`, body)
        .then((response) => {
          this.apiCallLoader = false;
          this.infoData = response.data;

          if (this.infoData.length != 0) {
            if(this.pageNumber == 1) {
              this.filteredData = this.infoData;
            } else {
              this.slice();
            }
          }
          this.isAjaxLoading = false;
          if (this.filteredData.length == 0) {
            this.noDataMsg = true;
          } else {
            this.noDataMsg = false;
          }
          this.searchClicked = false;
          this.tarckApplyFilter = false;
        });
    },
    getInfo() {
      axios
        .post(`${apiUrl}/Umbraco/Surface/Generic/GetAllFilters?culture=${language}`)
        .then((response) => {
          this.info = response.data;
          this.allCategories = this.info.Categories;

          // let UserObj = {};

          for (let item of this.info.Categories) {
            this.$set(item, "checked", false);
            item.SubCategories = item.SubCategories.map((str, index) => ({
              value: str,
              id: index + 1,
              checked: false,
            }));
          }

          for (let item of this.info.Sectors) {
            this.$set(item, "checked", false);
            item.Department = item.Department.map((str, index) => ({
              value: str,
              id: index + 1,
              checked: false,
            }));
          }
          this.addChecked(this.info.HealthProducts);
          this.addChecked(this.info.Functions);

          // for (let item of this.info.HealthProducts) {
          //   this.$set(item, "checked", false);
          // }

          // for (let item of this.info.Functions) {
          //   this.$set(item, "checked", false);
          // }

          // this.info = this.userIds;
        });
    },
    slice() {
      this.filteredData = this.filteredData.concat(this.infoData);
    },
    checkTrigger() {
        const options = {
          threshold: 0.1,
        };
        const checker = document.querySelector(".footer");
        const infiniteScroll = (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if(this.infoData.length != 0) {
                this.isAjaxLoading = true;
                setTimeout(() => {
                  this.pageNumber++;
                  this.getData();
                  this.isAjaxLoading = false;
                }, 500);
              }
            }
          });
        };

        const observer = new IntersectionObserver(infiniteScroll, options);
        observer.observe(checker);
    },
    addChecked(x) {
      if (x != null) {
        for (let item of x) {
          this.$set(item, "checked", false);
        }
      }
    },
  },
  mounted() {
    this.getData();
    this.getInfo();
    document.querySelector(".register-page-form__loader").style.display =
      "none";
    setTimeout(()=> {
      this.checkTrigger();
    }, 100)
  },
};
</script>
